import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-sm">
      <Link to="/" className="text-foreground-500 transition-colors hover:text-primary-600">
        主页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-300" />
          {item.to ? (
            <Link
              to={item.to}
              className="text-foreground-500 transition-colors hover:text-primary-600"
            >
              {item.label}
            </Link>
          ) : (
            <span className="font-medium text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}